import React, { useState } from "react";
import {
  Grid,
  GridItem,
  Box,
  Heading,
  Input,
  Button,
  Select,
  NumberInput,
  NumberInputField,
  VStack,
  FormControl,
  FormLabel,
  Flex,
} from "@chakra-ui/react";
import Sidebar from "../../../_ekdizayn/layout/Sidebar/Sidebar";
import NavBar from "../../../_ekdizayn/layout/Navbar/components/Header";
import QRCode from "react-qr-code";

export default function KarekodPage() {
  const [url, setUrl] = useState("https://ek.com.tr");
  const [color, setColor] = useState("#000000");
  const [size, setSize] = useState(256);
  const [margin, setMargin] = useState(2);
  const [logoUrl, setLogoUrl] = useState("");

  const mainColor = "#cd4023"; // form ana rengi

  return (
    <Grid
      templateAreas={`"header header"
                      "nav main"`}
      gridTemplateRows={"auto 1fr"}
      gridTemplateColumns={"auto 1fr"}
      h="100vh"
    >
      {/* Header */}
      <GridItem area={"header"}>
        <NavBar />
      </GridItem>

      {/* Sidebar */}
      <GridItem area={"nav"}>
        <Sidebar />
      </GridItem>

      {/* Main Content */}
      <GridItem area={"main"} p={5}>
        <Heading mb={6}>Karekod Generator</Heading>

        <Grid templateColumns="40% 60%" gap={6}>
          {/* Form Alanı (Sol %40) */}
          <Box>
            <VStack spacing={3} align="stretch">
              {/* URL */}
              <FormControl>
                <FormLabel>URL</FormLabel>
                <Input
                  placeholder="URL giriniz..."
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
              </FormControl>

              {/* Renk */}
              <FormControl>
                <FormLabel>Renk</FormLabel>
                <Input
                  type="color"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                  w="100px"
                />
              </FormControl>

              {/* Boyut */}
              <FormControl>
                <FormLabel>Boyut</FormLabel>
                <Select
                  value={size}
                  onChange={(e) => setSize(parseInt(e.target.value))}
                >
                  <option value={128}>128 px</option>
                  <option value={256}>256 px</option>
                  <option value={512}>512 px</option>
                </Select>
              </FormControl>

              {/* Margin */}
              <FormControl>
                <FormLabel>Margin</FormLabel>
                <NumberInput
                  value={margin}
                  min={0}
                  max={10}
                  onChange={(v) => setMargin(parseInt(v))}
                  maxW="120px"
                >
                  <NumberInputField />
                </NumberInput>
              </FormControl>

              {/* Logo URL */}
              <FormControl>
                <FormLabel>Logo URL</FormLabel>
                <Input
                  placeholder="Logo URL giriniz..."
                  value={logoUrl}
                  onChange={(e) => setLogoUrl(e.target.value)}
                />
              </FormControl>

              {/* Kaydet */}
              <Button
                variant="outline"
                borderColor={mainColor}
                color={mainColor}
              >
                Kaydet
              </Button>
            </VStack>
          </Box>

          {/* Preview Alanı (Sağ %60, sticky) */}
          <Box position="sticky" top="20px">
            <Box
              bg="white"
              p={4}
              display="inline-block"
              border="1px solid #ddd"
              borderRadius="md"
            >
              <QRCode
                value={url}
                size={size}
                fgColor={color}
                style={{ margin: margin }}
              />
            </Box>

            <Flex mt={4}>
              <Button variant="outline" borderColor={mainColor} color={mainColor} mr={3}>
                PNG İndir
              </Button>
              <Button variant="outline" borderColor={mainColor} color={mainColor}>
                SVG İndir
              </Button>
            </Flex>
          </Box>
        </Grid>
      </GridItem>
    </Grid>
  );
}
